export const SET_NETWORTH_HISTORY = "SET_NETWORTH_HISTORY";
